const icon = require('vue-svgicon');
icon.register({
    'upload-file': {
        width: 14,
        height: 18,
        viewBox: '0 0 14 18',
        data: `<path pid="0" d="M6.5 14.7693H7.5V10.075L9.6 12.175L10.3077 11.4615L7 8.15375L3.69225 11.4615L4.40575 12.1692L6.5 10.075V14.7693ZM1.6155 18C1.15517 18 0.770833 17.8458 0.4625 17.5375C0.154167 17.2292 0 16.8448 0 16.3845V1.6155C0 1.15517 0.154167 0.770833 0.4625 0.4625C0.770833 0.154167 1.15517 0 1.6155 0H9.5L14 4.5V16.3845C14 16.8448 13.8458 17.2292 13.5375 17.5375C13.2292 17.8458 12.8448 18 12.3845 18H1.6155ZM9 5V1H1.6155C1.4615 1 1.32042 1.06408 1.19225 1.19225C1.06408 1.32042 1 1.4615 1 1.6155V16.3845C1 16.5385 1.06408 16.6796 1.19225 16.8078C1.32042 16.9359 1.4615 17 1.6155 17H12.3845C12.5385 17 12.6796 16.9359 12.8077 16.8078C12.9359 16.6796 13 16.5385 13 16.3845V5H9Z" _fill="#000"/>`,
    },
});
